import { Auth, OAuthProvider, User } from 'firebase/auth'

export {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  signInAnonymously,
  signInWithCredential,
  linkWithCredential,
  sendPasswordResetEmail,
  signInWithCustomToken,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
  EmailAuthProvider,
  getAuth,
  getIdTokenResult,
} from 'firebase/auth'
export const AppleAuthProvider = OAuthProvider

// Web-specific types - create compatibility layer
export type FirebaseAuthTypes = {
  Module: Auth
  User: User
}
